/** Eroarea normalizată a API-ului (RFC 9457 `problem+json`); `code` = ultimul segment din `type`. */
export interface ValidationIssue {
  path?: string;
  code?: string;
  message?: string;
}

export class AppError extends Error {
  constructor(
    readonly status: number,
    readonly code: string,
    readonly title: string,
    readonly detail: string | undefined,
    readonly errors: ValidationIssue[] = [],
  ) {
    super(detail ?? title);
    this.name = 'AppError';
  }

  /** Mesajul pentru utilizator: detaliul serverului, altfel titlul. */
  get userMessage(): string {
    return this.detail ?? this.title;
  }

  static fromResponse(status: number, body: unknown): AppError {
    const b = (body ?? {}) as Record<string, unknown>;
    const type = typeof b.type === 'string' ? b.type : '';
    const code = type ? type.substring(type.lastIndexOf('/') + 1) : `http-${status}`;
    const title = typeof b.title === 'string' ? b.title : defaultTitle(status);
    const detail = typeof b.detail === 'string' ? b.detail : undefined;
    const errors = Array.isArray(b.errors) ? (b.errors as ValidationIssue[]) : [];
    return new AppError(status, code, title, detail, errors);
  }

  static network(err: unknown): AppError {
    return new AppError(
      0,
      'network',
      'Serverul nu răspunde',
      err instanceof Error ? err.message : undefined,
    );
  }
}

function defaultTitle(status: number): string {
  switch (status) {
    case 400:
      return 'Cererea nu este validă';
    case 401:
      return 'Neautentificat';
    case 403:
      return 'Acces interzis';
    case 404:
      return 'Nu a fost găsit';
    case 409:
      return 'Regulă de business încălcată';
    case 429:
      return 'Prea multe încercări';
    default:
      return `Eroare ${status}`;
  }
}

export function isAppError(e: unknown): e is AppError {
  return e instanceof AppError;
}

/** Mesaj scurt pentru toast-uri, indiferent de tipul erorii. */
export function errorMessage(e: unknown): string {
  if (isAppError(e)) return e.userMessage;
  if (e instanceof Error) return e.message;
  return 'Eroare neașteptată';
}
